import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { clearRedirect } from '../store/service/navigationSlice'
import { RootState } from '../store/store'

export const NavigationListener = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { redirectTo } = useSelector((state: RootState) => state.navigate)

    useEffect(() => {
        if (redirectTo) {
            navigate(redirectTo, { replace: true })
            dispatch(clearRedirect())
        }
    }, [redirectTo])

    return null
}
